import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { GroundTruthDocPage } from '@/features/GroundTruthHub/GroundTruthDocPage';
import { ingestedFileIdAndDocIdParams } from '@/features/GroundTruthHub/routeParams';
import { groundTruthRouteBoundaries } from '@/features/GroundTruthHub/GroundTruthNotFound';

const searchSchema = z.object({
    tab: z.string().optional(),
});

function DocPageRoute() {
    const { ingestedFileId, docId } = Route.useParams();
    const { tab } = Route.useSearch();
    return (
        <GroundTruthDocPage
            ingestedFileId={ingestedFileId}
            docId={docId}
            tabHint={tab}
        />
    );
}

export const Route = createFileRoute('/ground-truth/$ingestedFileId/$docId/')({
    ...groundTruthRouteBoundaries,
    component: DocPageRoute,
    params: ingestedFileIdAndDocIdParams,
    validateSearch: searchSchema,
});
